import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
// import './index.css';

//you also need to force webpack to copy index.html to build
// install https://www.npmjs.com/package/copy-webpack-plugin
// then use like this in webpack.config.js :
/*
module.exports = {
  plugins: [
    new CopyWebpackPlugin([{
      from: './*.html'
    }])
  ]
}
*/


if (module.hot) {
  // null => HMR triggers without reloading modules
  module.hot.accept(null, () => {
    console.log('Hot module replacement triggered!');
  });
}
if (module.hot) {
  module.hot.accept()
}

// suppress webpack dev overlay for known non-fatal errors
const suppressDevOverlay = (msg) => {
  return msg.includes('WhatsOnChain API does not support spends')
}
window.addEventListener('error', (e) => {
  if (suppressDevOverlay(e.message || '')) {
    e.preventDefault()
    e.stopPropagation()
  }
})
window.addEventListener('unhandledrejection', (e) => {
  const msg = (e.reason && (e.reason.message || String(e.reason))) || ''
  if (suppressDevOverlay(msg)) {
    e.preventDefault()
    e.stopPropagation()
  }
})


//open links externally by default
jQuery(document).on("click", 'a[href^="http"]', function(event) {
  if (window.electron) {
    event.preventDefault();
    window.electron.openExternalBrowser(this.href)
  }
});

const rootElement = document.getElementById('root')
ReactDOM.render(<App />, rootElement)

// we use our own service worker that only caches images & fonts for faster loads
// => no old js files compared to the default CRA service worker for PWAs
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('SW registered: ', registration);

      // ←←← THIS IS THE IMPORTANT PART (detect updates + show toast)
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New version is ready!
            if (window.confirm('New version available! Refresh now?')) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
              window.location.reload();
            }
          }
        });
      });
    }).catch(err => {
      console.error('SW registration failed: ', err);
    });
  });
}